import React from 'react';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * @type {import('$types/components/partials/icon.d.ts').IconArrowOutwards}
 */
const IconArrowOutwards = ({
    height = 32,
    width = 32
}) => {
    return (
        <svg
            aria-hidden='true'
            fill='none'
            height={height}
            viewBox='0 0 20 20'
            width={width}
            xmlns='http://www.w3.org/2000/svg'>
            <path
                d='M6.58232 13.889L12.978 7.49332L12.978 13.6419L13.6534 13.6533L13.6534 6.34648L6.34661 6.34649L6.35796 7.02192L12.5065 7.02192L6.11091 13.4176L6.58232 13.889Z'
                fill='currentColor' />
        </svg>
    );
};

/* ========================================================================= */
/* Typing and exports */
/* ========================================================================= */

export default IconArrowOutwards;
